/* © CNES */
import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { NavigateFunction } from 'react-router-dom';
import { getItemAvailability, getItemsAvailabilities } from './Items';

const QUERY_KEY = 'ItemAvailability';

/**
 * Interface for searchItems parameters.
 */
interface QueryItemAvailabilityModel {
  productId: string;
}

/**
 * Interface for searchItems parameters.
 */
// Définir une interface pour les objets dans X
interface Asset {
  href: string;
  type: string;
  "file:checksum": string;
}

interface Properties {
  "sat:absolute_orbit": number;
}
interface Item {
  id: string;
  bbox: number[];
  type: string;
  links: Array<{ rel: string; type: string; href: string }>;
  assets: {
    data: Asset;
    quicklook?: Asset;
  };
  properties: Properties;
}
export interface QueryItemsAvailabilitiesModel {
  availability: Item[];
}

/**
 * UseQuery synthax to call getItemAvailability from regards.
 * @param queryParams query Params.
 * @param navigate function to trigger navigation when error is returned.
 * @returns UseQueryResult.
 */
export const useGetItemAvailability = (
  queryParams: QueryItemAvailabilityModel,
  navigate: NavigateFunction,
  setError400: Function
) => {
  return useQuery({
    queryKey: [QUERY_KEY, queryParams, navigate, setError400],
    queryFn: getItemAvailability,
    refetchOnWindowFocus: false,
    enabled: !!queryParams?.productId,
    onError: (err: AxiosError) => {
      console.error(
        `product ${queryParams.productId} availibility request failed with error :  ${err}`
      );
    },
  });
};

/**
 * UseQuery synthax to call getItemAvailability from regards.
 * @param queryParams query Params.
 * @param navigate function to trigger navigation when error is returned.
 * @param setError400
 * @returns UseQueryResult.
 */
export const useGetItemsAvailabilities = (
  queryParams: QueryItemsAvailabilitiesModel
) => {
  return useQuery({
    queryKey: [QUERY_KEY, queryParams],
    queryFn: getItemsAvailabilities,
    refetchOnWindowFocus: false,
    enabled: !!queryParams?.availability?.length,
    onError: (err: AxiosError) => err,
  });
};
